<template>
  <v-container class="col-12">
    <v-card class="pa-4">
      <v-row class="mx-0 betslip-search-form" style="white-space: nowrap">
        <select-project
          v-model="project"
          :project-list-custom="projectList"
          class="report-base-filter"
          style="min-width: 200px"
        />

        <v-text-field
          v-model="round_id"
          label="RoundID"
          small
          hide-details
          class="col-2"
        />

        <v-label>OR</v-label>

        <v-text-field
          v-model="login"
          label="Login"
          placeholder="Login with prefix, ex: TT_TEST"
          hide-details
          class="report-base-filter pl-4"
          style="min-width: 230px; max-width: 230px"
        ></v-text-field>

        <date-picker
          v-if="!options.hideDate"
          v-model="from"
          label="Date From"
          style="width: 20%"
        />

        <date-picker
          v-if="!options.hideDate"
          v-model="to"
          label="Date To"
          style="width: 20%"
        />

        <v-btn
          color="info"
          class="mt-3 ml-3"
          :loading="sportHistory.loading"
          :disabled="sportHistory.loading"
          @click="search"
        >
          Search
        </v-btn>
      </v-row>
    </v-card>

    <v-divider />

    <template>
      <v-card class="col-12 pt-4 pb-4 px-4 mt-4">
        <v-data-iterator
          :items="sportHistory.items"
          :items-per-page="-1"
          hide-default-footer
        >

          <template v-slot:default="props">
            <v-row>
              <v-col
                v-for="item in props.items"
                :key="item.round_id"
                cols="12"
              >
                <v-card :id="'betslip-' + item.round_id">
                  <v-card-title class="subheading font-weight-bold">
                    ID: {{ item.round_id }}
                    <v-spacer />
                    <v-btn color="teal" @click="print('betslip-' + item.round_id)" dark icon>
                      <v-icon>print</v-icon>
                    </v-btn>
                  </v-card-title>

                  <v-divider></v-divider>

                  <v-list dense>
                    <v-list-item>
                      <v-list-item-content class="col-3">Account:</v-list-item-content>
                      <v-list-item-content class="col-9 align-end">{{ (item.prefix + item.login).toUpperCase() }}</v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="col-3">Status:</v-list-item-content>
                      <v-list-item-content class="col-9 align-end">{{ item.status }}</v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="col-3">Date:</v-list-item-content>
                      <v-list-item-content class="col-9 align-end">{{ item.created }}</v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="item.finalized">
                      <v-list-item-content class="col-3">Finalized:</v-list-item-content>
                      <v-list-item-content class="col-9 align-end">{{ item.finalized }}</v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="item.debit">
                      <v-list-item-content class="col-3">Bet:</v-list-item-content>
                      <v-list-item-content class="col-9 align-end">{{ item.currency }} {{ item.debit }}</v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="item.credit">
                      <v-list-item-content class="col-3">Income:</v-list-item-content>
                      <v-list-item-content class="col-9 align-end">{{ item.currency }} {{ item.credit }}</v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="!item.credit && item.potential_win">
                      <v-list-item-content class="col-3">Potential Win:</v-list-item-content>
                      <v-list-item-content class="col-9 align-end">{{ item.currency }} {{ item.potential_win }}</v-list-item-content>
                    </v-list-item>
                    <v-list-item style="padding: auto 6px">
                      <div class="col-12" style="padding: auto 0">
                        <div v-for="r in item.description" class="sport-event-description-item" style="width: 100%; border: 1px solid; padding: 8px 12px; margin-top: -1px;">
                          <div>
                            <template v-if="r.category_name">{{ r.category_name }},</template>
                            <template v-if="r.sport_name">{{ r.sport_name }},</template>
                            <template v-if="r.tournament_name">{{ r.tournament_name }},</template>
                            <template v-if="r.market_name">Market: {{ r.market_name }}</template>
                            <br />
                            {{ r.competitor_name.join(' - ') }}
                          </div>
                          <v-divider style="margin: 2px 0" />
                          <v-row style="margin: 0">
                            <div style="">Outcome: {{ r.outcome_name }}</div>
                            <v-spacer />
                            <div style="">Odds: {{ r.odds }}</div>
                          </v-row>
                        </div>
                      </div>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </template>

        </v-data-iterator>
      </v-card>
    </template>
  </v-container>
</template>

<style>
  .betslip-search-form .v-label {
    margin: auto
  }
</style>

<script>
  import moment from 'moment'
  import { find, get, map, filter } from 'lodash'
  import { API } from '@/utils/api'
  import { Printd } from 'printd'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    name: 'Betslip',

    props: { title: {}, projectList: { default: () => ([]) }, headers: {}, filters: {}, url: {}, defaultParams: { default: () => ({}) }, nowrap: { default: true }, table_size_fixed: { default: false }, options: { default: () => ({}) } },

    components: {
      SelectProject,
      DatePicker,
      Export: () => import('@/components/helper/Export')
    },

    data: () => ({
      dateRangeList: global.dateRangeList,
      project: null,
      login: null,
      from: moment().format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      round_id: null,
      sportHistory: {
        items: [],
        totalRows: [],
        options: {},
        expanded: [],
        loading: false,
        filters: {
          id: { data: [], type: 'text' },
          parent_id: { data: [], type: 'text' },
          action: { data: [], type: 'select' },
        },
        keys: [
          'created',
          'finalized',
          'round_id',
          'description',
          'debit',
          'credit',
          'status',
        ],
      },
    }),

    computed: {},

    mounted () {
      this.project = this.projectList[0].value
    },

    watch: {},

    methods: {
      search () {
        this.sportHistory.loading = true
        return API.call('/$v/reports/search_sport_bet.json', {
          round_id: this.round_id,
          login: this.login,
          from: this.from,
          to: this.to,
        }, null, this.project).then(resp => {
          this.sportHistory.items = resp.data
          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.sportHistory.loading = false
        })
      },

      print (id) {

        let stylesHtml = ''
        let stylesHrefs = []
        for (const node of [ ...document.querySelectorAll('link[rel="stylesheet"], style') ]) {
          if (!node.getAttribute('href')) {
            stylesHtml += node.innerHTML
          } else {
            stylesHrefs.push(node.getAttribute('href'))
          }
        }

        const d = new Printd()
        d.print(document.getElementById(id), [ stylesHtml, ...stylesHrefs ])

      },
      changeTimePeriod: function (value) {
        this.from = value.from
        this.to = value.to
      },

    },
  }
</script>
